import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import AboutUs from "../components/AboutUs";
import Courses from "../components/Courses";
import Placements from "../components/Placements";
import Contributions from "../components/Contributions";
import Mentors from "../components/Mentors";
import ClientWork from "../components/ClientWork";
import VideoSection from "../components/VideoSection";
import StudentComments from "../components/StudentComments";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="scroll-smooth">
      <Navbar />
      <HeroSection />
      <AboutUs />
      <Contributions />
      <Placements />
      <VideoSection />
      <div className="relative bg-[#090522] overflow-hidden">
        <div className="overflow-hidden bg-gradient-to-r from-purple-500 to-pink-500 py-4">
          <div className="w-max flex animate-marquee gap-4 whitespace-nowrap text-white font-bold px-4">
            {[
              "20+ Yrs Experience",
              "Pure Practical Learning",
              "Job-Ready Training",
              "Pro Industry Mentors",
              "Online + Offline Classes",
              "Career & Placement Assistance",
              "Small Focused Batches",
            ]
              .concat([
                "20+ Yrs Experience",
                "Pure Practical Learning",
                "Job-Ready Training",
                "Pro Industry Mentors",
                "Online + Offline Classes",
                "Career & Placement Assistance",
                "Small Focused Batches",
              ])
              .map((text, idx, arr) => (
                <span key={idx} className="flex items-center px-2">
                  {text}
                  {idx !== arr.length - 1 && (
                    <span className="mx-16" style={{ fontSize: "20px" }}>
                      ●
                    </span>
                  )}
                </span>
              ))}
          </div>
        </div>
      </div>

      <Courses />
      <ClientWork />
      <Mentors />
      <StudentComments />
      <Footer />
    </div>
  );
};

export default Home;
